<template>
    <div class="user_order" v-loading="loading">
        <div class="order_titles">问答详情</div>
        <div class="user_order_box  ">
            <div class="title_box">
                <div class="orders"></div>
                <div class="texts">我的问题</div>
            </div>
            <div class="info_box1">
                <div class="infos">
                    <div class="infos_title">{{ order_detial.content }}</div>
                    <div class="info_times">{{ order_detial.created_at }}提出</div>
                </div>
                <div v-if="order_detial.images.length" class="images">

                    <el-image style="width: 100px; height: 100px;margin-right: 10px;" :src="item" :preview-src-list="order_detial.images"  v-for="(item,index) in order_detial.images" :key="index"></el-image>
                </div>
            </div>
            <div class="title_box">
                <div class="orders"></div>
                <div class="texts">客服回复</div>
            </div>
            <div class="info_box2" v-if="!order_detial.answer">
                暂无回复
            </div>
            <div class="info_box2" v-if="order_detial.answer">
                {{order_detial.answer}}

            </div>
        </div>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            order_detial:{},
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_detial()
    },
    methods: {
        get_detial(){
            this.loading = true
            this.$api("caseLeaveInfo", {
             id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('我的咨询详情',res)
                if (res.code == 1) {
                  this.order_detial=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        // padding: 24px 32px;    
        min-height: 620px;
        padding-top: 21px;
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .title_box{
            display: flex;
            align-items: center;
            margin-bottom: 23px;
            .orders{
                width: 4px;
                height: 22px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
            }
            .texts{
                padding-left: 28px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 18px;
                color: #333333;

            }    
        }
        .info_box1{
            padding: 0 32px;
            margin-bottom: 40px;
            .infos{
                width: 1132px;
                min-height: 104px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 4px 4px 4px 4px;
                padding: 22px 24px;
                display: flex;
                flex-wrap: wrap;
                align-content: space-between;

                .infos_title{
                    width: 100%;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                    margin-bottom: 10px;

                }
                .info_times{
                    width: 100%;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #999999;
                }
            }
            .images{
                display: flex;
                align-items: center;
                padding-top: 10px;
            }
        }
        .info_box2{
            margin-top: 24px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 18px;
            color: #999999;
            padding: 0 32px;
        }
    }


}
</style>